<template>
	<address>
		<div v-if="!editable">
			<strong class="d-block"><slot name="label">{{ label }}</slot></strong>
			<span class="text-pre-wrap">{{ addressFormat(value) }}</span>
		</div>
		<b-card id="address" no-body v-else>
			<template #header>
				<b-card-title>{{ label }}</b-card-title>

				<div class="card-options">
					<b-button
						variant="link"
						v-if="isEditing"
						:disabled="isLoading"
						@click.prevent="storeSiteName"
					><span class="icon fa fa-fw fa-save"></span></b-button>
					<b-button
						variant="link"
						:disabled="isLoading || (employeeAuthenticated && !employeeIsAdmin)"
						@click.prevent="toggleEditing"
						v-b-tooltip.hover :title="editingTooltip"
					><span class="icon fa fa-fw" :class="editingIcon"></span></b-button>
				</div>
			</template>

			<b-card-body>
				<b-form-group
					v-if="isEditing"
					:disabled="isLoading || (employeeAuthenticated && !employeeIsAdmin)"
				>
					<b-form-input
						autofocus
						maxlength="80"
						ref="address-label"
						v-model="addressLabel"
						:placeholder="editingPlaceholder"
						v-b-tooltip.hover :title="editingPlaceholder"
					/>
				</b-form-group>

				<span class="text-pre-wrap">{{ addressFormat(value) }}</span>
			</b-card-body>
		</b-card>
	</address>
</template>

<style>
#address {
	border: none;
}
#address .card-header, #address .card-body {
	padding: inherit !important;
}
</style>

<script>
import { order } from '@/mixins'

export default
{
	mixins: [ order ],

	data()
	{
		return {
			isEditing: false,
			addressLabel: this.value?.label,
		}
	},

	props:
	{
		value:
		{
			type:    Object,
			default: null,
		},

		label:
		{
			type:    String,
			default: null,
		},

		editable:
		{
			type:    Boolean,
			default: false,
		},
	},

	computed:
	{
		editingIcon()
		{
			return (this.isEditing) ? 'fa-ban' : 'fa-pencil'
		},

		editingTooltip()
		{
			return (this.isEditing) ? 'Cancel' : 'Rename'
		},

		editingPlaceholder()
		{
			return 'Customer Identifier for ' + this.label
		},
	},

	methods:
	{
		toggleEditing()
		{
			this.isEditing = !this.isEditing
			if (this.isEditing)
			{
				this.$refs['address-label']?.focus()
			}
		},

		storeSiteName()
		{
			if (this.value?.label === this.addressLabel)
			{
				this.toggleEditing()
				return
			}

			return this.$store.dispatch(this.Types.ORDER_SITE_NAME, { orderId: this.order.id, address: this.value, label: this.addressLabel })
				.then(_ => this.value.label = this.addressLabel)
				.then(this.toggleEditing)
				.catch(this.catchError)
				.finally(this.removeLoading)
		},
		
	},
}
</script>